module.exports = __webpack_public_path__ + "static/media/1012857.b1919e2a.png";